import { isSponsoredCampaign } from 'services/campaignDimension';
import { isSponsoredAccount } from '../../../account-management';

export const isSponsoredAccountAndDimension = ({ selectedAccount: { partnerTypes }, dimension, isRealtime }) =>
    isSponsoredAccount(partnerTypes) && isSponsoredCampaign(dimension) && !isRealtime;
